import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';

// Utils
import { useTranslation } from 'react-i18next'
import { InputContainer, InputText, ButtonText, CustomIconButton } from './styles';

export const SearchBarCompanyWorkers = ({
    handleChangeFilter,
    handleFilters,
    searchText,
    clearFilter 
}) => {

    const { t } = useTranslation();
    const [search, setSearch] = React.useState('')

    function handleSearch(e) {
        setSearch(e)
        searchText.current = e
    }

    React.useEffect(() => {
        handleSearch("")
    },[clearFilter?.current])

    return (
        <InputContainer
            component="form"
            elevation={0}
        >
            <InputText
                type='text'
                name='search'
                value={search}
                onChange={e => handleSearch(e.target.value)}
                onKeyDown={e => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleFilters()
                    }
                }}
                autoComplete='off'
                placeholder={t('common.searchBars.worker')}
                inputProps={{ 'aria-label': 'search google maps' }}
            />
            <CustomIconButton type="button" aria-label="search" onClick={handleChangeFilter}>
                <ButtonText pr={1}>
                  {t("common.search")}
                </ButtonText>
                <SearchIcon />
            </CustomIconButton>
        </InputContainer>
    );
}